export enum IncidentDetailsEnum {
    Incident = 1,
    Feedback = 2,
    ECPB = 3,
    Leader = 4,
    Radio = 5
}
export enum RailOperationResultEnum {
    Dump = 1,
    Penalty = 2,
    Stoppage = 3,
    Parting = 4,
    Derailment = 5
}